import tagTester from "./_tagTester.js";
import has from "./_has.js";
var isArguments = tagTester("Arguments");
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return has(obj, "callee");
    };
  }
})();
export default isArguments;
